import { mirrorX, smoothCorner } from "apparatus/draw";
import { Gradients } from "apparatus/gradients";
import { P, Pivot, R, Segments, SharedGradients } from "apparatus/library/common";
import { Group, Path, Shape } from "paper";
const metalGradient = SharedGradients.cylinderMetal;
const bracketMetalGradient = Gradients.simple("#aaaaaa".color(), 20);
const softMetalGradient = Gradients.simple("#aaaaaa".color(), 10);
export class HoffmanClamp {
    render(appearance) {
        const graphic = (() => {
            switch (appearance.view) {
                case "front": return frontView;
                case "side": return sideView;
            }
        })()(appearance);
        return {
            graphic,
            hitShape: graphic.bounds.toShape(),
            pivot: P(0, 5),
        };
    }
}
HoffmanClamp.properties = {
    label: "Hoffman Clamp",
    defaultAppearance: {
        view: "front",
        clamping: 0.5,
        size: 30,
    },
    appearanceSpecs: [
        {
            spec: "radio", key: "view", label: "View",
            options: [
                { value: "side", label: "Side" },
                { value: "front", label: "Front" },
            ],
        },
        {
            spec: "slider", key: "size", label: "Size",
            min: 25, max: 50, step: 0.1, unit: "mm"
        },
        {
            spec: "slider", key: "clamping", label: "Clamping",
            min: 0.0, max: 1.0, step: 0.01, unit: "%",
        },
    ],
};
function createScrew(height) {
    return new Group([
        Shape.Rectangle(R(0, height - 5, 8, height, Pivot.BOTTOM_CENTER)).withGradientFill("right", metalGradient),
        Shape.Rectangle(R(0, -5, 20, 8, Pivot.BOTTOM_CENTER), 2.0).withGradientFill("right", metalGradient),
    ]);
}
function frontView(appearance) {
    const height = appearance.size;
    const halfWidth = height / 3 * 2;
    const slide = (height - 10) * (1 - appearance.clamping);
    const bracket = new Path(Segments([[-halfWidth, height]], [[-halfWidth, 0]]));
    mirrorX(bracket);
    smoothCorner(bracket.segments[2], 3);
    smoothCorner(bracket.segments[1], 3);
    bracket.strokeWidth = 5.0;
    bracket.setGradientStroke("right-down", bracketMetalGradient);
    const bottom = Shape.Rectangle(R(0, height, halfWidth * 2 + 10, 5, Pivot.CENTER), 2.0).withGradientFill("down", softMetalGradient);
    const slidingPart = Shape.Rectangle(R(0, height - 5 - slide, halfWidth * 2 + 10, 5, Pivot.CENTER), 2.0).withGradientFill("down", softMetalGradient);
    const screw = createScrew(height);
    screw.position.y -= slide;
    return new Group([screw, bracket, bottom, slidingPart]);
}
function sideView(appearance) {
    const height = appearance.size;
    const slide = (height - 10) * (1 - appearance.clamping);
    const bracket = Shape.Rectangle(R(0, 0, 16, height, Pivot.TOP_CENTER), 2.0);
    bracket.setGradientFill("right-down", bracketMetalGradient);
    const bottom = Shape.Rectangle(R(0, height, 18, 5, Pivot.CENTER), 2.0).withGradientFill("down", softMetalGradient);
    const slidingPart = Shape.Rectangle(R(0, height - 5 - slide, 18, 5, Pivot.CENTER), 2.0).withGradientFill("down", softMetalGradient);
    const screw = createScrew(height);
    screw.position.y -= slide;
    return new Group([screw, bracket, bottom, slidingPart]);
}
